export default __webpack_public_path__ + "static/Screenshot-c02b8ad4855e786df171cb33dbb53b0d.jpg";